import { ChatMessageResponse, ChatResponse } from "@/data/dtos/responses";
import { SendChatMessageInput } from "@/domain/dtos/inputs";
import { NotFoundError } from "@/domain/errors";
import { ApiService } from "@/domain/clients";
import { Endpoints } from "@/infra/api";
import { ChatDataSource } from "./ChatDataSource";

export class ChatRemoteDataSource implements ChatDataSource {
  constructor(private readonly api: ApiService) {}

  async getChats(): Promise<ChatResponse[]> {
    const { data } = await this.api.get<ChatResponse[]>(Endpoints.chats);

    if (!data) {
      return [];
    }

    return data;
  }

  async getChatById(id: number) {
    const { data } = await this.api.get<ChatResponse>(
      `${Endpoints.chats}/${id}`,
    );

    if (!data) {
      throw new NotFoundError("Chat");
    }

    return data;
  }

  async sendMessage(params: SendChatMessageInput) {
    const { data } = await this.api.post<
      ChatMessageResponse,
      SendChatMessageInput
    >(Endpoints.chat_messages, params);
    if (!data) {
      throw new NotFoundError("Mensagem");
    }
    return data;
  }

  async getMessages(chatId: number) {
    const { data } = await this.api.get<ChatMessageResponse[]>(
      Endpoints.chat_messages,
      { appointment_chat_id: chatId },
    );

    if (!data) {
      return [];
    }

    return data;
  }

  async editMessage(id: number | string, message: string) {
    const { data } = await this.api.put<ChatMessageResponse, { message: string }>(
      `${Endpoints.chat_messages}/${id}`,
      { message },
    );
    if (!data) {
      throw new NotFoundError("Mensagem");
    }
    return data;
  }

  async pinChat(chatId: number) {
    await this.api.post(`${Endpoints.chats}/${chatId}/pin`, {});
  }

  async archiveChat(chatId: number) {
    await this.api.post(`${Endpoints.chats}/${chatId}/archive`, {});
  }
}
